import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';

const useStyles = makeStyles((theme) => ({
  addEventButton: {
    backgroundColor: '#4CAF50',
    width:'95%',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#45a049',
    },
    padding: theme.spacing(1, 2),
    borderRadius: theme.shape.borderRadius,
    fontSize: '1rem',
    fontWeight: 500,
    margin: '1rem 0rem',
    textTransform: 'none',
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(1),
    },
  },
}));

const AddEventButton = () => {
  const classes = useStyles();

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<EditCalendarIcon />}
      className={classes.addEventButton}
    >
      Add Event
    </Button>
  );
};

export default AddEventButton;
